module.exports = {
      id: "chinese-traditional-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#chinese-traditional-usage",
      toString: function () {
        return this.url;
      }
    }